// ========================================
// Role Permissions View — matriz de qué rol ve cada sección
// Solo Admin. Persiste en GlobalSettings.rolePermissions vía
// GET/PUT /api/role-permissions.
// ========================================

const RolePermissionsView = {
    permissions: {},
    filterText: '',
    filter: 'all',          // 'all' | 'unset' | 'student' | 'none'
    saveTimer: null,
    collapsed: new Set(),
    previewRole: null,
    history: [],            // earlier matrices, for «Deshacer»
    grants: {},             // module → [{ name, level }] (people with a grant in their ficha)
    // Staff sections: giving them to Alumno or Almacén shows a warning.
    STAFF_ONLY: ['rrhh-dash', 'alumnocrm-dash', 'profesores', 'profesor-ficha', 'nominas', 'justificantes', 'tutorias-admin', 'alumnado', 'alumno-ficha', 'leads',
        'email-templates', 'pre-matricula', 'entrevistas', 'settings', 'email-settings', 'gestion-tareas', 'calificaciones-admin', 'documentos', 'acciones-pendientes', 'planificacion-mensual'],

    ROLES: [
        { key: 'admin', label: 'Admin', hue: 175 },
        { key: 'coordinator', label: 'Coordinador', hue: 235 },
        { key: 'rrhh', label: 'RRHH', hue: 340 },
        { key: 'professor', label: 'Profesor', hue: 285 },
        { key: 'student', label: 'Alumno', hue: 140 },
        { key: 'warehouse', label: 'Almacén', hue: 55 }
    ],

    GROUPS: [
        { name: 'Dashboards de departamento', hue: null, icon: 'fa-gauge-high' },
        { name: 'Académico', hue: 175, icon: 'fa-graduation-cap' },
        { name: 'Alumnado y CRM', hue: 235, icon: 'fa-users-gear' },
        { name: 'RRHH', hue: 340, icon: 'fa-id-card-clip' },
        { name: 'Logística', hue: 55, icon: 'fa-truck-ramp-box' },
        { name: 'Transversales', hue: null, icon: 'fa-layer-group' }
    ],

    SECTIONS: [
        { key: 'dashboard', group: 'Dashboards de departamento', label: 'Dashboard General' },
        { key: 'panel-academico', group: 'Dashboards de departamento', label: 'Bloque «Académico» del Inicio' },
        { key: 'academico-dash', group: 'Dashboards de departamento', label: 'Dashboard Académico' },
        { key: 'alumnocrm-dash', group: 'Dashboards de departamento', label: 'Dashboard CRM Alumnado' },
        { key: 'rrhh-dash', group: 'Dashboards de departamento', label: 'Dashboard RRHH' },
        { key: 'logistica-dash', group: 'Dashboards de departamento', label: 'Dashboard Logística' },

        { key: 'formaciones', group: 'Académico', label: 'Formaciones y Cursos' },
        { key: 'plan-estudios', group: 'Académico', label: 'Plan de Estudios' },
        { key: 'calendario', group: 'Académico', label: 'Calendario General' },
        { key: 'calendario-formacion', group: 'Académico', label: 'Programación Lectiva' },
        { key: 'memorias-asignatura', group: 'Académico', label: 'Memorias de Asignatura' },
        { key: 'gestion-tareas', group: 'Académico', label: 'Gestión de Tareas (staff)' },
        { key: 'tareas', group: 'Académico', label: 'Mis Tareas (alumno)' },
        { key: 'mapa-interactivo', group: 'Académico', label: 'Mapa Interactivo' },
        { key: 'asistencia', group: 'Académico', label: 'Control de Asistencia' },
        { key: 'calificaciones-admin', group: 'Académico', label: 'Calificaciones y Actas (gestión)' },
        { key: 'calificaciones-alumno', group: 'Académico', label: 'Mis Calificaciones (alumno)' },

        { key: 'alumnado', group: 'Alumnado y CRM', label: 'Gestión de Alumnado' },
        { key: 'leads', group: 'Alumnado y CRM', label: 'Contactos y Leads' },
        { key: 'email-templates', group: 'Alumnado y CRM', label: 'Plantillas Email' },
        { key: 'pre-matricula', group: 'Alumnado y CRM', label: 'Pre-Matrícula' },
        { key: 'entrevistas', group: 'Alumnado y CRM', label: 'Entrevistas de Admisión' },
        { key: 'alumno-ficha', group: 'Alumnado y CRM', label: 'Ficha individual de Alumno' },

        { key: 'profesores', group: 'RRHH', label: 'Gestión de Profesores' },
        { key: 'profesor-ficha', group: 'RRHH', label: 'Ficha individual de Profesor' },
        { key: 'nominas', group: 'RRHH', label: 'Nóminas' },
        { key: 'justificantes', group: 'RRHH', label: 'Gestión de Justificantes' },
        { key: 'tutorias-admin', group: 'RRHH', label: 'Gestión de Tutorías (staff)' },
        { key: 'tutorias-alumno', group: 'RRHH', label: 'Mis Tutorías (alumno)' },
        // Fixed rules (js/modules/role-permissions.js canView): shown, not editable here.
        { key: 'planificacion-mensual', group: 'RRHH', label: 'Planificación mensual', fixed: ['admin', 'rrhh'], rule: 'Solo Administración, RRHH y quien tenga el permiso en su ficha.' },
        { key: 'mi-nomina', group: 'RRHH', label: 'Mi nómina', fixed: ['admin', 'rrhh'], rule: 'Quien gestiona las nóminas y tiene ficha de personal; el resto ve la suya en «Nóminas».' },

        { key: 'almacen', group: 'Logística', label: 'Almacén y Materiales' },
        { key: 'distribucion', group: 'Logística', label: 'Distribución y Catálogo' },

        { key: 'mensajes', group: 'Transversales', label: 'Mensajería Interna' },
        { key: 'comunidad', group: 'Transversales', label: 'Comunidad' },
        { key: 'profile', group: 'Transversales', label: 'Mi Perfil' },
        { key: 'settings', group: 'Transversales', label: 'Configuración del Sistema' },
        { key: 'email-settings', group: 'Transversales', label: 'Configuración Email' },
        { key: 'buscar', group: 'Transversales', label: 'Buscador Global' },
        { key: 'documentos', group: 'Transversales', label: 'Documentos del Profesor' },
        { key: 'acciones-pendientes', group: 'Transversales', label: 'Acciones Pendientes' }
    ],

    render() {
        if (!AuthManager.isAdmin()) {
            return `
                <div class="card perm-denied">
                    <i class="fas fa-lock"></i>
                    <p>Esta sección es solo para administradores.</p>
                </div>
            `;
        }
        return `
            <div class="perm-view pra dnr-proposal" style="padding-top: 1rem;">
                <div class="pra-main">
                    <div class="pra-head">
                        <div class="pra-head-title"><div class="dnr-hero-eyebrow pra-eyebrow">Ajustes</div><h1>Permisos por rol</h1></div>
                        <span class="perm-status" id="perm-status-pill" data-state="idle"><span class="dot"></span><span id="perm-status-text">Cargando…</span></span>
                        <button type="button" class="pra-btn" id="perm-undo" disabled ${UIEvents.attr("click", function(event,captured){RolePermissionsView.undo();}, [])}><i class="fas fa-rotate-left" aria-hidden="true"></i> Deshacer</button>
                    </div>
                    <div class="pra-what"><b>Qué hace</b><span>Decide qué ve cada rol en el <b>menú y en los paneles</b>. Lo que cada persona puede consultar o cambiar lo controla SICAF por dentro y los permisos que se dan a una persona en su ficha. Administración lo ve siempre todo. Los cambios se guardan solos.</span></div>
                    <div class="pra-toolbar">
                        <input type="search" class="pra-input" id="perm-filter-input" placeholder="Buscar sección" aria-label="Buscar sección" autocomplete="off"
                            ${UIEvents.attr("input", function(event,captured){RolePermissionsView.handleFilter(this.value);}, [])}>
                        <select class="pra-input" id="perm-filter-select" aria-label="Filtrar secciones" ${UIEvents.attr("change", function(event,captured){RolePermissionsView.setFilter(this.value);}, [])}></select>
                        <span class="pra-spacer"></span>
                        <button type="button" class="pra-btn" id="perm-fold-all" ${UIEvents.attr("click", function(event,captured){RolePermissionsView.toggleAllGroups();}, [])}>Plegar grupos</button>
                    </div>
                    <div class="perm-table-scroll pra-scroll">
                        <table class="perm-table pra-table" id="perm-table">
                            <tbody><tr><td class="perm-empty">Cargando matriz de permisos…</td></tr></tbody>
                        </table>
                    </div>
                    <p class="pra-foot">El cuadrado de cada grupo marca o quita todo el grupo para ese rol (— = solo algunas). ⚠: una sección del personal dada al Alumno o al Almacén. «Sin configurar»: nadie la ha tocado y la ven todos. «Regla fija»: la decide SICAF y no se cambia aquí.</p>
                </div>
                <aside class="pra-preview" id="perm-preview" hidden></aside>
            </div>
        `;
    },

    async init() {
        if (!AuthManager.isAdmin()) return;
        await Promise.all([this.loadPermissions(), this.loadGrants()]);
        this.renderTable();
    },

    async loadPermissions() {
        try {
            const response = await fetch('/api/role-permissions', { headers: { 'X-SICAF-CSRF': AuthManager.getCsrfToken() } });
            const data = await response.json();
            if (data.success) this.permissions = data.permissions || {};
        } catch (error) {
            console.error('Error al cargar la matriz de permisos:', error);
            this.showStatus('error', 'Error al cargar');
        }
    },

    async loadGrants() {
        try {
            const response = await fetch('/api/module-access/summary', { headers: { 'X-SICAF-CSRF': AuthManager.getCsrfToken() } });
            const data = await response.json().catch(() => null);
            this.grants = response.ok && data?.success ? data.modules || {} : {};
        } catch { this.grants = {}; }
    },

    section(key) { return this.SECTIONS.find(s => s.key === key); },
    isSet(sectionKey) { return !!this.permissions[sectionKey]; },
    // What the menu really does: a section nobody configured is visible to every role.
    isChecked(sectionKey, roleKey) {
        const s = this.section(sectionKey);
        if (roleKey === 'admin') return true;
        if (s?.fixed) return s.fixed.includes(roleKey);
        if (!this.permissions[sectionKey]) return true;
        return !!this.permissions[sectionKey][roleKey];
    },

    setChecked(sectionKey, roleKey, value) {
        if (roleKey === 'admin' || this.section(sectionKey)?.fixed) return;
        // First change to an unconfigured section: start from what it does today (everyone sees it).
        if (!this.permissions[sectionKey]) this.permissions[sectionKey] = Object.fromEntries(this.ROLES.map(r => [r.key, true]));
        this.permissions[sectionKey][roleKey] = value;
    },

    rowCount(sectionKey) { return this.ROLES.reduce((n, r) => n + (this.isChecked(sectionKey, r.key) ? 1 : 0), 0); },

    _people(sectionKey) {
        const module = typeof RolePermissions !== 'undefined' && RolePermissions.moduleForSection ? RolePermissions.moduleForSection(sectionKey) : sectionKey;
        return this.grants[module] || [];
    },

    _shown() {
        const q = Utils.normalizeString ? Utils.normalizeString(this.filterText.trim()) : this.filterText.trim().toLowerCase();
        const norm = v => Utils.normalizeString ? Utils.normalizeString(v) : String(v).toLowerCase();
        return this.SECTIONS.filter(s => (!q || norm(s.label).includes(q))
            && (this.filter !== 'unset' || (!s.fixed && !this.isSet(s.key)))
            && (this.filter !== 'student' || this.isChecked(s.key, 'student'))
            && (this.filter !== 'none' || this.rowCount(s.key) <= 1));
    },

    // Kept as the entry point (the tests call it): the whole matrix from the current state.
    renderTable() {
        const table = document.getElementById('perm-table');
        if (!table) return;
        const shown = this._shown();
        const searching = !!this.filterText.trim() || this.filter !== 'all';
        const head = `<thead><tr><th class="perm-col-label">Sección</th>${this.ROLES.map(r => `<th class="pra-role">
            <span class="pra-role-name">${Utils.sanitizeHTML(r.label)}</span>
            ${r.key === 'admin' ? '<span class="pra-role-sub">siempre todo</span>' : `<button type="button" class="pra-role-btn ${this.previewRole === r.key ? 'is-on' : ''}" aria-pressed="${this.previewRole === r.key}"
                ${UIEvents.attr("click", function(event,captured){RolePermissionsView.togglePreview(String(captured[0]));}, [r.key])}>${this.previewRole === r.key ? 'viendo menú' : 'ver menú'}</button>
                <button type="button" class="pra-role-btn" title="Marcar o quitar toda la columna" ${UIEvents.attr("click", function(event,captured){RolePermissionsView.toggleColumn(String(captured[0]));}, [r.key])}>toda la columna</button>`}
        </th>`).join('')}<th class="perm-col-count">Roles</th></tr></thead>`;
        let rows = '';
        this.GROUPS.forEach(group => {
            const list = shown.filter(s => s.group === group.name);
            if (!list.length) return;
            const open = searching || !this.collapsed.has(group.name);
            const groupCells = this.ROLES.map(r => {
                const editable = list.filter(s => !s.fixed);
                const n = list.filter(s => this.isChecked(s.key, r.key)).length;
                const all = n === list.length, part = n > 0 && !all;
                const locked = r.key === 'admin' || !editable.length;
                return `<td class="pra-cell"><button type="button" class="pra-box is-group ${all ? 'is-on' : part ? 'is-part' : ''} ${locked ? 'is-locked' : ''}" ${locked ? 'disabled' : ''}
                    aria-label="${Utils.sanitizeHTML(group.name)} · ${Utils.sanitizeHTML(r.label)}: ${all ? 'todas' : part ? 'algunas' : 'ninguna'}" title="Marcar o quitar todo el grupo para este rol"
                    ${UIEvents.attr("click", function(event,captured){RolePermissionsView.toggleGroup(String(captured[0]),String(captured[1]));}, [group.name, r.key])}>${all ? '✓' : part ? '—' : ''}</button></td>`;
            }).join('');
            rows += `<tr class="perm-group-row pra-group"><td class="perm-col-label"><button type="button" class="pra-fold" aria-expanded="${open}" ${searching ? 'disabled' : ''}
                ${UIEvents.attr("click", function(event,captured){RolePermissionsView.toggleGroupOpen(String(captured[0]));}, [group.name])}><span aria-hidden="true">${open ? '▾' : '▸'}</span> ${Utils.sanitizeHTML(group.name)} <small>${list.length} ${list.length === 1 ? 'sección' : 'secciones'}</small></button></td>${groupCells}<td></td></tr>`;
            if (!open) return;
            list.forEach(s => {
                const people = this._people(s.key);
                const cells = this.ROLES.map(r => {
                    const on = this.isChecked(s.key, r.key);
                    const locked = r.key === 'admin' || !!s.fixed;
                    const risky = on && ['student', 'warehouse'].includes(r.key) && this.STAFF_ONLY.includes(s.key);
                    return `<td class="pra-cell"><button type="button" class="pra-box ${on ? 'is-on' : ''} ${!this.isSet(s.key) && !s.fixed && r.key !== 'admin' ? 'is-default' : ''} ${risky ? 'is-risky' : ''} ${locked ? 'is-locked' : ''}" ${locked ? 'disabled' : ''}
                        aria-pressed="${on}" aria-label="${Utils.sanitizeHTML(s.label)} — ${Utils.sanitizeHTML(r.label)}" title="${risky ? 'Sección del personal: ¿seguro que la debe ver este rol?' : locked ? (r.key === 'admin' ? 'Administración lo ve siempre todo' : Utils.sanitizeHTML(s.rule || '')) : ''}"
                        ${UIEvents.attr("click", function(event,captured){RolePermissionsView.toggleCell(String(captured[0]),String(captured[1]));}, [s.key, r.key])}>${risky ? '⚠' : on ? '✓' : ''}</button></td>`;
                }).join('');
                rows += `<tr class="perm-row pra-row"><td class="perm-col-label"><span class="perm-row-label">${Utils.sanitizeHTML(s.label)}</span>
                    ${s.fixed ? `<span class="pra-tag is-fixed" title="${Utils.sanitizeHTML(s.rule)}">regla fija</span>` : !this.isSet(s.key) ? '<span class="pra-tag" title="Nadie la ha configurado: la ven todos los roles">sin configurar</span>' : ''}
                    ${people.length ? `<span class="pra-tag is-people" title="${Utils.sanitizeHTML(people.map(p => `${p.name} (${p.level === 'manage' ? 'gestionar' : 'consultar'})`).join(', '))}">+${people.length} ${people.length === 1 ? 'persona' : 'personas'}</span>` : ''}
                    </td>${cells}<td class="perm-count"><span class="perm-count-pill">${this.rowCount(s.key)}/${this.ROLES.length}</span></td></tr>`;
            });
        });
        SafeHTML.set(table, head + `<tbody>${rows || `<tr><td colspan="${this.ROLES.length + 2}" class="perm-empty">Sin resultados para «${Utils.sanitizeHTML(this.filterText)}».</td></tr>`}</tbody>`);
        this.renderFilters();
        this.renderPreview();
        const fold = document.getElementById('perm-fold-all');
        if (fold) fold.textContent = this.collapsed.size ? 'Desplegar grupos' : 'Plegar grupos';
        const undo = document.getElementById('perm-undo');
        if (undo) undo.disabled = !this.history.length;
        if (!this.saveTimer) this.showStatus('idle', this.history.length ? 'Guardado' : 'Sin cambios');
    },

    renderFilters() {
        const select = document.getElementById('perm-filter-select');
        if (!select) return;
        const unset = this.SECTIONS.filter(s => !s.fixed && !this.isSet(s.key)).length;
        const none = this.SECTIONS.filter(s => this.rowCount(s.key) <= 1).length;
        SafeHTML.set(select, [['all', 'Todas las secciones'], ['unset', `Sin configurar · ${unset}`], ['none', `Solo Administración · ${none}`], ['student', 'Que ve el Alumno']]
            .map(([v, label]) => `<option value="${v}" ${this.filter === v ? 'selected' : ''}>${label}</option>`).join(''));
    },

    // The menu as the chosen role will see it, in the order of the groups.
    renderPreview() {
        const box = document.getElementById('perm-preview');
        if (!box) return;
        const role = this.ROLES.find(r => r.key === this.previewRole);
        box.hidden = !role;
        if (!role) return;
        const items = this.SECTIONS.filter(s => this.isChecked(s.key, role.key));
        SafeHTML.set(box, `<div class="pra-preview-head"><span class="pra-label">Menú de ${Utils.sanitizeHTML(role.label)}</span>
            <button type="button" class="pra-close" aria-label="Cerrar la vista del menú" ${UIEvents.attr("click", function(event,captured){RolePermissionsView.togglePreview('');}, [])}>×</button></div>
            ${this.GROUPS.map(g => { const list = items.filter(s => s.group === g.name); return list.length ? `<span class="pra-label pra-preview-group">${Utils.sanitizeHTML(g.name)}</span>${list.map(s => `<span class="pra-preview-item">${Utils.sanitizeHTML(s.label)}</span>`).join('')}` : ''; }).join('')}
            <small class="pra-preview-note">Solo es lo que aparece en su menú; dentro, SICAF decide qué puede hacer.</small>`);
    },

    _change(fn) {
        this.history.push(JSON.stringify(this.permissions));
        if (this.history.length > 30) this.history.shift();
        fn();
        this.renderTable();
        this.schedulePersist();
    },

    toggleCell(sectionKey, roleKey) { this._change(() => this.setChecked(sectionKey, roleKey, !this.isChecked(sectionKey, roleKey))); },
    toggleGroup(groupName, roleKey) {
        const list = this._shown().filter(s => s.group === groupName && !s.fixed);
        const allOn = list.every(s => this.isChecked(s.key, roleKey));
        this._change(() => list.forEach(s => this.setChecked(s.key, roleKey, !allOn)));
    },
    toggleColumn(roleKey) {
        const list = this.SECTIONS.filter(s => !s.fixed);
        const allOn = list.every(s => this.isChecked(s.key, roleKey));
        this._change(() => list.forEach(s => this.setChecked(s.key, roleKey, !allOn)));
    },
    toggleGroupOpen(name) { if (this.collapsed.has(name)) this.collapsed.delete(name); else this.collapsed.add(name); this.renderTable(); },
    toggleAllGroups() { this.collapsed = this.collapsed.size ? new Set() : new Set(this.GROUPS.map(g => g.name)); this.renderTable(); },
    togglePreview(roleKey) { this.previewRole = this.previewRole === roleKey || !roleKey ? null : roleKey; this.renderTable(); },
    setFilter(value) { this.filter = ['unset', 'student', 'none'].includes(value) ? value : 'all'; this.renderTable(); },

    undo() {
        if (!this.history.length) return;
        this.permissions = JSON.parse(this.history.pop());
        this.renderTable();
        this.schedulePersist();
    },

    handleFilter(value) {
        this.filterText = value;
        this.renderTable();
        const input = document.getElementById('perm-filter-input');
        if (input) { input.focus(); input.setSelectionRange?.(value.length, value.length); }
    },

    schedulePersist() {
        this.showStatus('pending', 'Guardando…');
        clearTimeout(this.saveTimer);
        this.saveTimer = setTimeout(() => this.persist(), 600);
    },

    async persist() {
        this.saveTimer = null;
        try {
            const response = await fetch('/api/role-permissions', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-SICAF-CSRF': AuthManager.getCsrfToken() },
                body: JSON.stringify({ permissions: this.permissions })
            });
            const data = await response.json();
            this.showStatus(data.success ? 'saved' : 'error', data.success ? 'Guardado hace un momento' : 'Error al guardar');
            if (data.success && typeof RolePermissions !== 'undefined') RolePermissions.matrix = JSON.parse(JSON.stringify(this.permissions));
        } catch (error) {
            console.error('Error al guardar la matriz de permisos:', error);
            this.showStatus('error', 'Sin conexión');
        }
    },

    showStatus(state, text) {
        const pill = document.getElementById('perm-status-pill');
        const txt = document.getElementById('perm-status-text');
        if (pill) pill.dataset.state = state;
        if (txt) txt.textContent = text;
    }
};

window.RolePermissionsView = RolePermissionsView;
